import React, { useState } from "react";
import { Link } from "react-router-dom";

import "../styles/MobileNav.scss";

const MobileNav = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <nav className="mobile-nav">
      <div className="nav-toggle" onClick={toggleNav}>
        <div className={`bar ${isNavOpen ? "open" : ""}`}></div>
        <div className={`bar ${isNavOpen ? "open" : ""}`}></div>
        <div className={`bar ${isNavOpen ? "open" : ""}`}></div>
      </div>
      <ul className={`nav-menu ${isNavOpen ? "open" : ""}`}>
        <li>
          <Link
            to={`${process.env.PUBLIC_URL}/artists/directors`}
            onClick={toggleNav}
          >
            Directors{" "}
          </Link>
        </li>
        <li>
          <Link
            to={`${process.env.PUBLIC_URL}/artists/photographers`}
            onClick={toggleNav}
          >
            Photographers
          </Link>
        </li>
        <li>
          <a
            href={`
            https://estelleleeds.slateapp.com/showreel/shared/6a7b3427a1c35`}
            rel="noopener noreferrer"
            target="_blank"
          >
            Multi Talent Reel
          </a>
        </li>
        <li>
          <Link to={`${process.env.PUBLIC_URL}/clients`}>Clients </Link>
        </li>
        <li>
          <Link to={`${process.env.PUBLIC_URL}/biography`}>Biography </Link>
        </li>
        <li>
          <Link to={`${process.env.PUBLIC_URL}/contact`}>
            Contact / Production Collaborators
          </Link>
        </li>
        {/* Add more navigation items as needed */}
      </ul>
    </nav>
  );
};

export default MobileNav;
